import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NGXLogger } from 'ngx-logger';
import { SchedeService } from '../../../services/schede.service';
import { Scheda } from '../../../models/scheda.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}
@Component({
  selector: 'app-carica-allegato',
  templateUrl: './carica-allegato.component.html',
  styleUrls: ['./carica-allegato.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    FileUploadModule,
    ToastModule,
    LottieComponent
  ],
  providers: [MessageService]
})
export class CaricaAllegatoComponent {
  @Input() visible: boolean = false;
  @Input() scheda: Scheda | null = null;
  @Input() tipoAllegato: 'pdf' | 'xls' = 'pdf';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() allegatoCaricato = new EventEmitter<Scheda | null>();

  file: File | null = null;
  isUploading: boolean = false;

  options: AnimationOptions = {
    path: '/assets/animations/spinner-uploading.json',
    loop: true,
    autoplay: true
  };
  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private schedeService: SchedeService,
    private firebaseStorageService: FirebaseStorageService
  ) {
    this.logger.updateConfig({
      level: 0,
      serverLoggingUrl: undefined,
      serverLogLevel: 0
    });
  }

  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.reset();
  }

  onFileSelect(event: any) {
    this.file = event.files[0];
  }

  onClear() {
    this.file = null;
  }

  caricaAllegato() {
    if (!this.file || !this.scheda) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Seleziona un file da caricare'
      });
      return;
    }

    this.isUploading = true;
    if(this.tipoAllegato === 'pdf'){
      this.scheda.pdfCaricato = true;
    } else {
      this.scheda.xlsCaricato = true;
    }

    // Prima elimino il file precedente se esiste
    const pathPrecedente = this.tipoAllegato === 'pdf' ? this.scheda.percorsoPdf : this.scheda.percorsoXls;
    if (pathPrecedente) {
      const fullPathPrecedente = `schede/${this.scheda.codice}/allegati/${pathPrecedente}`;
      this.firebaseStorageService.deleteFile(fullPathPrecedente).subscribe({
        next: () => {
          this.logger.info(`[CARICA ALLEGATO] File precedente eliminato con successo: ${fullPathPrecedente}`);

        },
        error: (error: Error) => {
          this.logger.error(`[CARICA ALLEGATO] Errore durante l'eliminazione del file precedente:`, error);
         /*  this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore durante l\'eliminazione del file precedente'
          }); */
          this.isUploading = false;
        }
      });
      this.caricaNuovoFile();
    } else {
      this.caricaNuovoFile();
    }
  }

  private caricaNuovoFile() {
    const path = `schede/${this.scheda?.codice}/allegati/${this.file?.name}`;

    this.firebaseStorageService.uploadFile(this.file!, path).subscribe({
      next: (url) => {
        if(this.tipoAllegato === 'pdf'){
          this.scheda!.percorsoPdf = this.file!.name;
        } else {
          this.scheda!.percorsoXls = this.file!.name;
        }

        this.schedeService.modifica(this.scheda!).subscribe({
          next: () => {
            this.logger.info(`[CARICA ALLEGATO] Scheda ${this.scheda?.codice} modificata con successo #1`);

            this.allegatoCaricato.emit(this.scheda);
            this.onHide();
          },
          error: (error: Error) => {
            this.logger.error(`[CARICA ALLEGATO] Errore durante la modifica della scheda:`, error);
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore durante il caricamento del file'
            });
            this.isUploading = false;
          },
          complete: () => {
            //this.logger.info(`[CARICA ALLEGATO] Scheda ${this.scheda?.codice} modificata con successo #2`);
           // this.allegatoCaricato.emit(this.scheda);
            this.onHide();
          }
        });
      },
      error: (error: Error) => {
        this.logger.error(`[CARICA ALLEGATO] Errore durante il caricamento del file:`, error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il caricamento del file'
        });
        this.isUploading = false;
      }
    });
  }

  private reset() {
    this.file = null;
    this.isUploading = false;
    this.scheda = null;
  }
}
